import { Delete } from "@mui/icons-material";
import {
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  useTheme
} from "@mui/material";
import axios from "axios";
import _ from "lodash";
import moment from "moment";
import React, { forwardRef, memo, useEffect, useImperativeHandle, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import { useStyle } from "../style";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
const BillingTable = forwardRef((props, ref) => {
  const theme = useTheme();
  const classes = useStyle();
  const {data, setData,code, setCode, setPostData} = props
  const [itemData, setItemData] = useState(null)
  const [qty, setQty] = useState('')
    const [fromDate, setFromDate] = useState(null);
  const [selectedBatchDate, setSelectedBatchDate] = useState(null);      
  const dispatch = useDispatch()
  
  const [rateData, setRateData] = useState({
    mrp : '',
    disc : 0 ,
    rate :'',
    gst : '',
    batch_expiry_date: null,
  })
  const [editingIndex, setEditingIndex] = useState(null);
  const codeRef = useRef(null)
  const qtyRef = useRef(null)
  const priceRef = {
    mrp : useRef(null),
    gst : useRef(null),
    rate : useRef(null),
    disc : useRef(null),
    
  }
  const updatedRef = {
    mrp : useRef(null),
    gst : useRef(null),
    rate : useRef(null),
    disc : useRef(null),
    qty : useRef(null)
  }
  const handleCodeKeyPress = (e) =>{
      if(e.key === "Enter" && code!==''){
          getItemCode(code)
      }
  }
  const handleDateChange = (newDate, index) => {
    const updated = [...data];
    updated[index].batch_expiry_date = moment(newDate).format('YYYY-MM-DD');
    setData(updated);
    console.log('Updated Row:', updated[index]);
  };
//   const handleAddRow = (e) => {
//     console.log(rateData, "rateData");
//     if (e.key === 'Enter' && qty !== '') {
//         const objData = {
//             code: code,
//             qty: qty,
//             mrp1: rateData.mrp,
//             rate1: rateData.rate,
//             gst1: rateData.gst,
//             disc1: rateData.disc === "" ? "0" : rateData.disc,
//             gstAmt: parseFloat((parseFloat(rateData.rate) - parseFloat(rateData.rate) * parseFloat(rateData.disc) / 100) * (parseFloat(rateData.gst) / 100) * parseFloat(qty)).toFixed(0),
//             cessAmt: parseFloat((parseFloat(rateData.rate) - parseFloat(rateData.rate) * parseFloat(rateData.disc) / 100) * (parseFloat(itemData.cess) / 100) * parseFloat(qty)).toFixed(0),
//             totalAmt: parseFloat((rateData.rate - rateData.rate * rateData.disc / 100) * qty).toFixed(0),
//     batch_expiry_date: itemData?.is_batch ? moment().format('YYYY-MM-DD') : null,

//       ...JSON.parse(JSON.stringify(itemData))
    
//             //  ...itemData
//         };
        
//         const arr = [...data];
        
//         // Clear the input fields
//         setCode('');
//         setQty('');
//         setItemData(null);
//         setRateData((prevData) => ({ ...prevData, mrp: "", rate: "", gst: "", disc: "" }));

//         // Always add the new item to the array without checking for existing entries
//         arr.push(objData);
        
//         setData(arr);
//         codeRef.current.focus();
//     }
// };
const handleAddRow = (e) => {
  if (e.key === 'Enter' && qty !== '') {
    const objData = {
      code: code,
      qty: qty,
      mrp1: rateData.mrp,
      rate1: rateData.rate,
      gst1: rateData.gst,
      disc1: rateData.disc === '' ? '0' : rateData.disc,
      gstAmt: parseFloat((parseFloat(rateData.rate) - parseFloat(rateData.rate) * Number(rateData.disc) / 100) * (parseFloat(rateData.gst) / 100) * parseFloat(qty)).toFixed(0),
      // gstAmt: parseFloat((parseFloat(rateData.rate) - parseFloat(rateData.rate) * parseFloat(rateData.disc) / 100) * (parseFloat(rateData.gst) / 100) * parseFloat(qty)).toFixed(0),
      cessAmt: parseFloat((parseFloat(rateData.rate) - parseFloat(rateData.rate) * parseFloat(rateData.disc) / 100) * (parseFloat(itemData?.cess || 0) / 100) * parseFloat(qty)).toFixed(0),
      totalAmt: parseFloat((rateData.rate - rateData.rate * rateData.disc / 100) * qty).toFixed(0),
      ...JSON.parse(JSON.stringify(itemData)),
      batch_expiry_date: itemData?.is_batch ? rateData.batch_expiry_date : null
    
    };
console.log(objData,"objData1333");

    const arr = [...data];
    arr.push(objData);
    setData(arr);
    setCode('');
    setQty('');
    setItemData(null);
    setRateData({
      mrp: '',
      rate: '',
      gst: '',
      disc: '',
      batch_expiry_date: null
    });
    codeRef.current?.focus();
  }
};


console.log(itemData,"itemData99999");

  // const handleAddRow=(e)=>{
  //   console.log(rateData,"rateData")
  //     if(e.key==='Enter' && qty!==''){
  //         const objData = {
  //             code: code,
  //             qty: qty,
  //             mrp1: rateData.mrp,
  //             rate1: rateData.rate,
  //             gst1: rateData.gst,
  //             disc1: rateData.disc==="" ? "0" : rateData.disc,
  //             gstAmt:parseFloat((parseFloat(rateData.rate) - parseFloat(rateData.rate) * parseFloat(rateData.disc) / 100) * (parseFloat(rateData.gst) / 100) * parseFloat(qty)).toFixed(0),
  //             cessAmt: parseFloat((parseFloat(rateData.rate) - parseFloat(rateData.rate) * parseFloat(rateData.disc) / 100) * (parseFloat(itemData.cess) / 100) * parseFloat(qty)).toFixed(0),
  //             totalAmt: parseFloat((rateData.rate - rateData.rate * rateData.disc / 100) * qty).toFixed(0),
  //             ...itemData
  //         }
  //         const existingItemIndex = data.findIndex((item) => item.code === objData.code );
  //         const arr = [...data]
  //         setData([])
  //         if (existingItemIndex) {
  //         // if (existingItemIndex !== -1) {
  //         // If the item exists, update its quantity, gst, cess, total
  //           arr[existingItemIndex].gst1 = parseFloat(objData.gst1);
  //           arr[existingItemIndex].rate1 = parseFloat(objData.rate1);
  //           arr[existingItemIndex].mrp1 = parseFloat(objData.mrp1);
  //           arr[existingItemIndex].qty = parseFloat(arr[existingItemIndex].qty) + parseFloat(objData.qty);
  //           arr[existingItemIndex].gstAmt = (parseFloat(arr[existingItemIndex].rate1)-parseFloat(arr[existingItemIndex].rate1) * parseFloat(arr[existingItemIndex].disc1 / 100)) * (parseFloat(arr[existingItemIndex].gst1  / 100))* parseFloat(arr[existingItemIndex].qty);
  //           arr[existingItemIndex].cessAmt = (parseFloat(arr[existingItemIndex].rate1)-parseFloat(arr[existingItemIndex].rate1) * parseFloat(arr[existingItemIndex].disc1 / 100)) * (parseFloat(arr[existingItemIndex].cess / 100))* parseFloat(arr[existingItemIndex].qty);
  //           arr[existingItemIndex].totalAmt = (parseFloat(arr[existingItemIndex].rate1)-parseFloat(arr[existingItemIndex].rate1) * parseFloat(arr[existingItemIndex].disc1 / 100)) * parseFloat(arr[existingItemIndex].qty);
  //           setData(arr)
  //         } else {
  //         // If the item doesn't exist, add it to the 'data' array
  //           arr.push(objData)
  //           setData(arr)
  //         }
  //         setCode('')
  //         setQty('')
  //         setItemData(null)
  //         setRateData((prevData) => ({ ...prevData, mrp: "", rate: "", gst : "", disc : "" }))
  //         codeRef.current.focus()
  //     }
  // }
//   const handleAddRow = (e) => {
//     console.log(rateData, "rateData");
//     if (e.key === 'Enter' && qty !== '') {
//         const objData = {
//             code: code,
//             qty: qty,
//             mrp1: rateData.mrp,
//             rate1: rateData.rate,
//             gst1: rateData.gst,
//             disc1: rateData.disc === "" ? "0" : rateData.disc,
//             gstAmt: parseFloat((parseFloat(rateData.rate) - parseFloat(rateData.rate) * parseFloat(rateData.disc) / 100) * (parseFloat(rateData.gst) / 100) * parseFloat(qty)).toFixed(0),
//             cessAmt: parseFloat((parseFloat(rateData.rate) - parseFloat(rateData.rate) * parseFloat(rateData.disc) / 100) * (parseFloat(itemData.cess) / 100) * parseFloat(qty)).toFixed(0),
//             totalAmt: parseFloat((rateData.rate - rateData.rate * rateData.disc / 100) * qty).toFixed(0),
//             ...itemData
//         };
//         const existingItemIndex = data.findIndex((item) => item.code === objData.code);
//         const arr = [...data];

//         // Clear the input fields
//         setCode('');
//         setQty('');
//         setItemData(null);
//         setRateData((prevData) => ({ ...prevData, mrp: "", rate: "", gst: "", disc: "" }));

//         if (existingItemIndex !== -1) {
//             // If the item exists, replace it with the new item
//             arr[existingItemIndex] = objData;
//         } else {
//             // If the item doesn't exist, add it to the 'data' array
//             arr.push(objData);
//         }

//         setData(arr);
//         codeRef.current.focus();
//     }
// };

  const handleDeleteRow=(e, i)=>{
    const updateArr = [...data]
    updateArr.splice(i,1)
    setData(updateArr)
  }
  const handleQtyChange = (e) =>{
      setQty(e.target.value)
  }
  const handleCodeChange = (e) =>{
      // setCode(e.target.value)
      setCode(e.target.value.toUpperCase());
  }
const handleKeyPress = (e) =>{
if(e.key==='Enter' && e.target.value!=='' ){
  const nextRef = e.target.name
checkRef(nextRef)
}
}
const handleDiscPress = (e) =>{
  if(e.key==='Enter' && e.target.name == 'disc'){
    console.log('vanthudu', e.target.name)
    const nextRef = e.target.name
    checkRef(nextRef)
  }
}
function checkRef(value){
  console.log(value, rateData.disc)
  if(value=='mrp'){
    priceRef.gst.current.focus()
  }
  else if(value == 'gst'){
    priceRef.rate.current.focus()
  }
  else if(value == 'rate'){
    priceRef.disc.current.focus()
  }
  else if(value == 'disc'){
    if(rateData.disc===''){
      console.log('first')
      setRateData(prev=> ({...prev, disc : '0'}))
      qtyRef.current.focus()
    }
    else{
      qtyRef.current.focus()
      setRateData(prev=> ({...prev, disc : '0'}))
    }
  }
}
const handleRateChange = (e) =>{
  setRateData((prevData) => ({...prevData, [e.target.name] : e.target.value}))
}
  const getItemCode = (id) =>{
    axios.get(`/v1/ItemCode/${id}`)
    .then(res=>{
      setItemData(res.data)
      setRateData((prevData) => ({ ...prevData, mrp: res.data.mrp, rate: res.data.pur_rate, gst : res.data.gst }));
      priceRef.mrp.current.focus()
    })
    .catch(err=>{
      console.log(err.response.data.errors[0].message)
      dispatch(setSnackbar(true , "error" ,err.response.data.errors[0].message ))
    })
  }
  const clearNew = () =>{
    setCode('')
    setQty('')
    setItemData(null)
    setRateData((prevData) => ({ ...prevData, mrp: "", rate: "", gst : "", disc : "" }))
    codeRef.current.focus()
  }
  const handleEditChange = (e, name) => {
    const arr=[...data]
    const value = e.target.value.replace(/\D/g, '')
    setData([])
    if(name==='gst'){
      arr[editingIndex].gst1 = value
     arr[editingIndex].gstAmt = parseFloat((arr[editingIndex].rate1 - arr[editingIndex].rate1 * arr[editingIndex].disc1 / 100) * (value / 100) * arr[editingIndex].qty).toFixed(0)
      setData(arr)
    }
    else if(name==='mrp'){
      arr[editingIndex].mrp1 = value
      setData(arr)
    }
    else if(name==='rate'){
      arr[editingIndex].rate1 = value
     arr[editingIndex].gstAmt = parseFloat((value - value * arr[editingIndex].disc1 / 100) * (arr[editingIndex].gst1 / 100) * arr[editingIndex].qty).toFixed(0)
     arr[editingIndex].totalAmt = parseFloat((value - value * arr[editingIndex].disc1 / 100)  * arr[editingIndex].qty).toFixed(0)
     arr[editingIndex].cessAmt= parseFloat((value - value * arr[editingIndex].disc1 / 100) * (arr[editingIndex].cess / 100) * arr[editingIndex].qty).toFixed(0)
      setData(arr)
    }
    else if(name==='disc'){
      let discValue = value==='' ? 0 :  value
      arr[editingIndex].disc1 = value
     arr[editingIndex].gstAmt = parseFloat((arr[editingIndex].rate1 - arr[editingIndex].rate1 * parseFloat(discValue) / 100) * (arr[editingIndex].gst1 / 100) * arr[editingIndex].qty).toFixed(0)
     arr[editingIndex].totalAmt = parseFloat((arr[editingIndex].rate1 - arr[editingIndex].rate1 *  parseFloat(discValue) / 100)  * arr[editingIndex].qty).toFixed(0)
     arr[editingIndex].cessAmt= parseFloat((arr[editingIndex].rate1 - arr[editingIndex].rate1 * parseFloat(discValue) / 100) * (arr[editingIndex].cess / 100) * arr[editingIndex].qty).toFixed(0)
      setData(arr)
    }
    else if(name==='qty'){
      arr[editingIndex].qty = value
     arr[editingIndex].gstAmt = parseFloat((arr[editingIndex].rate1 - arr[editingIndex].rate1 * arr[editingIndex].disc1 / 100) * (arr[editingIndex].gst1 / 100) * value).toFixed(0)
     arr[editingIndex].totalAmt = parseFloat((arr[editingIndex].rate1 - arr[editingIndex].rate1 * arr[editingIndex].disc1 / 100)  * value).toFixed(0)
     arr[editingIndex].cessAmt= parseFloat((arr[editingIndex].rate1 - arr[editingIndex].rate1 * arr[editingIndex].disc1 / 100) * (arr[editingIndex].cess / 100) * value).toFixed(0)
      setData(arr)
    }
  };
 function getSelectedRow(e){
  setEditingIndex(e)
 }
 function handleUpdatedKey(e){
    if(e.key==='Enter' && e.target.value!=='' ){
      const nextRef = e.target.name
      checkUpdatedRef(nextRef)
    }
    else if(e.key==='Enter' && e.target.name==='disc'){
      const nextRef = e.target.name
      checkUpdatedRef(nextRef)
    }
 }
 function checkUpdatedRef(value){
if(value==='mrp'){
updatedRef.gst.current.focus()
}
else if(value==='gst'){
updatedRef.rate.current.focus()
}
else if(value==='rate'){
  updatedRef.disc.current.focus()
  }
  else if(value==='disc'){
    const arr = [...data];
    setData([])
    if(arr[editingIndex].disc1===''){
      arr[editingIndex].disc1 = 0
      arr[editingIndex].gstAmt = parseFloat(arr[editingIndex].rate1 )
       arr[editingIndex].totalAmt = parseFloat(arr[editingIndex].rate1 )
       arr[editingIndex].cessAmt= parseFloat(arr[editingIndex].rate1 )
    }
    setData(arr)
    updatedRef.qty.current.focus()
    }
  else if(value==='qty'){
addToData()
  }
 }
 function addToData(){
codeRef.current.focus()
 }
 useImperativeHandle(ref, () => ({
  focusCodeInput: () => {
    setQty('')
    setItemData(null)
    setRateData((prevData) => ({ ...prevData, mrp: "", rate: "", gst : "", disc : "" }))
    codeRef.current.focus()
  }
}));
useEffect(() => {
if(data.length > 0){
  let arr=[]
  data.map(val=>{
    const obj = {
      docdate:moment().format('YYYY/MM/DD'),
      proid:val.id,
      dis_per:val.disc1,
      dis_amt:parseFloat((val.rate1 -(val.rate1 * (100 - val.disc1 )/ 100)) * val.qty).toFixed(0),
      mrp:val.mrp1,
      rate:val.rate1,
      qty:val.qty,
      gst_per:val.gst1,
      gst_amt: parseFloat(val.gstAmt).toFixed(0),
      cess_per:val.cess,
      cess_amt:val.cessAmt,
      barcode:  val.barcode,
      head_id: val.head_id ,
      type_id:  val.type ,
      subcat_id:  val.sub_cat ,
      cat_id:  val.cat_id ,
      uom_id:  val.uom ,
        //  batch_expiry_date: val.batch_expiry_date
        // ? moment(val.batch_expiry_date).format('YYYY-MM-DD')
        // : null,
        batch_expiry_date: val.batch_expiry_date
  ? moment(val.batch_expiry_date).format('YYYY-MM-DD')
  : null,

    }
    arr.push(obj)
  })
  setPostData((prevState)=>({...prevState, purchase_details: arr}))
}
},[data])

return (
  <LocalizationProvider dateAdapter={AdapterDayjs}>
  <Grid className="w-full h-full">
    <TableContainer className={classes.tblRoot}>
      <Table stickyHeader  className={classes.table}>
        <TableHead className={classes.tblHeader}>
          <TableRow className={classes.tablrow}>
            <TableCell className={classes.tblCell} sx={{borderLeft:'0.5px solid  #ccc'}}>Sno</TableCell>
            <TableCell className={classes.tblCell}>Product Code</TableCell>
            <TableCell className={classes.tblCell}>Product Name</TableCell>
            <TableCell className={classes.tblCell}>Batch Expiry</TableCell>
            <TableCell className={classes.tblCell}>MRP</TableCell>
            <TableCell className={classes.tblCell}>GST%</TableCell>
            <TableCell className={classes.tblCell}>Rate</TableCell>
            <TableCell className={classes.tblCell}>Dis%</TableCell>
            <TableCell className={classes.tblCell}>Qty</TableCell>
            <TableCell className={classes.tblCell}>GST</TableCell>
            {/* <TableCell className={classes.tblCell}>CESS</TableCell> */}
            <TableCell className={classes.tblCell}>Amount</TableCell>
            <TableCell className={classes.tblCell}>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {_.map(data, (val, idx) => (
             <TableRow className={classes.tablrow} key={idx} onClick={() => getSelectedRow(idx)}>
             <TableCell  padding="checkbox" className={classes.tblContentCell} sx={{borderLeft:'0.5px solid  #ccc'}}>{idx + 1}</TableCell>
                   <TableCell>{val.code}</TableCell>
             <TableCell variant="body" className={classes.tblContentCell}>{val.pro_name}</TableCell>
 <TableCell>
    {val.is_batch === true && (
      // <DatePicker
      //   value={val.batch_expiry_date ? dayjs(val.batch_expiry_date) : dayjs()}
      //   onChange={(newValue) => {
      //     const updatedData = [...data];
      //     updatedData[idx].batch_expiry_date = newValue;
      //     setData(updatedData);
      //   }}
      //     onKeyPress={handleUpdatedKey}
      //   slotProps={{
      //     textField: {
      //       size: "small",
      //       sx: { width: 140 },
      //     },
      //   }}
      // />
//  <DatePicker
//     value={val.batch_expiry_date ? dayjs(val.batch_expiry_date) : null}
//     onChange={(newValue) => {
//       const updatedData = [...data];
//       updatedData[idx].batch_expiry_date = newValue;
//       setData(updatedData);
//     }}
//     disabled={!val.is_batch} // disables if false
//     slotProps={{
//       textField: {
//         size: "small",
//         sx: { width: 140 },
//       },
//     }}
//   />
<DatePicker
    value={val.batch_expiry_date ? dayjs(val.batch_expiry_date) : null}
    onChange={(newValue) => {
      const updatedData = [...data];
      updatedData[idx] = {
        ...updatedData[idx],
        batch_expiry_date: newValue ? newValue.format("YYYY-MM-DD") : null,
      };
      setData(updatedData);
    }}
    disabled={!val.is_batch}
    slotProps={{
      textField: {
        size: "small",
        sx: { width: 140 },
      },
    }}
  />

    )} 
  
  </TableCell>



             <TableCell padding="checkbox" className={classes.tblContentCell} sx={{width:100}} >
                  <TextField
                    size="small"
                    inputRef={editingIndex===idx ? updatedRef.mrp : null}
                    name="mrp"
                    value={val.mrp1}
                    onChange={(e) => handleEditChange(e, "mrp")}
                    onKeyPress={handleUpdatedKey}
                    inputProps={{style:{textAlign:"center"}}}
                    className={classes.tableInput}
                  />
             </TableCell>
             <TableCell padding="checkbox"  className={classes.tblContentCell} sx={{width:100}}>
             <TextField
                    size="small"
                    inputRef={editingIndex===idx ? updatedRef.gst : null}
                    name="gst"
                    value={val.gst1}
                    onChange={(e) => handleEditChange(e, "gst")}
                    onKeyPress={handleUpdatedKey}
                    inputProps={{style:{textAlign:"center"}}}
                    className={classes.tableInput}
                  />
             </TableCell>
             <TableCell padding="checkbox"  className={classes.tblContentCell} sx={{width:100}}>
             <TextField
                    size="small"
                    inputRef={editingIndex===idx ? updatedRef.rate : null}
                    name="rate"
                    value={ val.rate1}
                    onChange={(e) => handleEditChange(e, "rate")}
                    onKeyPress={handleUpdatedKey}
                    inputProps={{style:{textAlign:"center"}}}
                  />
             </TableCell>
             <TableCell padding="checkbox"  className={classes.tblContentCell} sx={{width:100}}>
             <TextField
                    size="small"
                    inputRef={editingIndex===idx ? updatedRef.disc : null}
                    name="disc"
                    value={val.disc1 }
                    onChange={(e) => handleEditChange(e, "disc")}
                    className={classes.tableInput}
                    onKeyPress={handleUpdatedKey}
                    InputProps={{style:{outline: 'none', border: 'none',boxShadow:"none",textAlign:"center"}}}
                  />
             </TableCell>
             <TableCell>
             <TextField
                    size="small"
                    inputRef={editingIndex===idx ? updatedRef.qty : null}
                    name="qty"
                    value={ val.qty}
                    className={classes.tableInput}
                    onChange={(e) => handleEditChange(e, "qty")}
                    onKeyPress={handleUpdatedKey}
                    InputProps={{style:{outline: 'none', border: 'none',boxShadow:"none",textAlign:"center"}}}
                  />
             </TableCell>
             <TableCell className={classes.tblContentCell} sx={{width:100}}>{parseFloat(val.gstAmt).toFixed(0)}</TableCell>
             {/* <TableCell className={classes.tblContentCell} sx={{width:100}}>{parseFloat(val.cessAmt).toFixed(0)}</TableCell> */}
             <TableCell className={classes.tblContentCell} sx={{width:100}}>{parseFloat(val.totalAmt).toFixed(0)}</TableCell>
             <TableCell className={classes.tblContentCell} sx={{width:100}}><IconButton onClick={()=>handleDeleteRow(val, idx)}><Delete sx={{color:'red', fontSize:18}}/></IconButton></TableCell>
           </TableRow>
          ))}
          <TableRow className={classes.tablrow}>
            <TableCell  padding="checkbox" className={classes.tblContentCell} sx={{borderLeft:'0.5px solid  #ccc'}}>{data.length + 1}</TableCell>
            <TableCell  padding="checkbox" sx={{ width: 120 }} className={classes.tblContentCell}>
            <TextField
              inputRef={codeRef}
              size='small'
              value={code}
              onChange={handleCodeChange}
              onKeyPress={handleCodeKeyPress}
              autoComplete='off'
              InputProps={{style:{outline: 'none', border: 'none',boxShadow:"none",}}}
              // className={classes.tableInput}
              className={classes.tableInput}
             />
            </TableCell>


            <TableCell variant="body" className={classes.tblContentCell}>{itemData!==null && itemData.pro_name }</TableCell>
            <TableCell className={classes.tblContentCell} sx={{ width: 150 }}>
    <LocalizationProvider dateAdapter={AdapterDayjs}>
   
      <DatePicker
  value={rateData.batch_expiry_date ? dayjs(rateData.batch_expiry_date) : null}
  onChange={(newValue) => {
    setRateData((prev) => ({
      ...prev,
      batch_expiry_date: newValue ? dayjs(newValue).format("YYYY-MM-DD") : null
    }));
  }}
  disabled={itemData?.is_batch === false || itemData === null}
  slotProps={{ textField: { size: "small" } }}
/>

    </LocalizationProvider>
  </TableCell>
            <TableCell padding="checkbox" className={classes.tblContentCell} sx={{width:100}}>
              <TextField
              inputRef={priceRef.mrp}
              name="mrp"
              size="small"
              disabled={code===''}
              value={rateData.mrp}
              onChange={handleRateChange}
              onKeyPress={handleKeyPress}
              inputProps={{style:{textAlign:"center"}}}
              />
              </TableCell>
            <TableCell padding="checkbox" className={classes.tblContentCell} sx={{width:100}}>
              <TextField
                inputRef={priceRef.gst}
                name="gst"
                size="small"
                disabled={code===''}
                value={rateData.gst}
                onChange={handleRateChange}
                onKeyPress={handleKeyPress}
              InputProps={{style:{outline: 'none', border: 'none',boxShadow:"none",textAlign:"center"}}}
              />
            </TableCell>
            <TableCell padding="checkbox" className={classes.tblContentCell} sx={{width:100}}>
            <TextField
                inputRef={priceRef.rate}
                name="rate"
                size="small"
                disabled={code===''}
                value={rateData.rate}
                onChange={handleRateChange}
                onKeyPress={handleKeyPress}
                InputProps={{style:{outline: 'none', border: 'none',boxShadow:"none",textAlign:"center"}}}
              />
            </TableCell>
            <TableCell padding="checkbox" className={classes.tblContentCell} sx={{width:100}}>
            <TextField
                inputRef={priceRef.disc}
                name="disc"
                size="small"
                disabled={code===''}
                value={rateData.disc}
                className={classes.tableInput}
                onChange={handleRateChange}
                onKeyPress={handleDiscPress}
                InputProps={{style:{outline: 'none', border: 'none',boxShadow:"none",textAlign:"center"}}}
              />
            </TableCell>
            <TableCell padding="checkbox" sx={{ width: 120 }}  className={classes.tblContentCell}>
            <TextField
              size='small'
              inputRef={qtyRef}
              value={qty}
              disabled={code===''}
              onChange={handleQtyChange}
              className={classes.tableInput}
              onKeyPress={handleAddRow}
              InputProps={{style:{outline: 'none', border: 'none',boxShadow:"none",textAlign:"center"}}}
             />
            </TableCell>
            <TableCell className={classes.tblContentCell} sx={{width:100}}>{itemData!==null && parseFloat((rateData.rate - rateData.rate * rateData.disc / 100) * (rateData.gst / 100) * qty).toFixed(0) }</TableCell>
            {/* <TableCell className={classes.tblContentCell} sx={{width:100}}>{itemData!==null && parseFloat((rateData.rate - rateData.rate * rateData.disc / 100) * (itemData.cess / 100) * qty).toFixed(0) }</TableCell> */}
            <TableCell className={classes.tblContentCell} sx={{width:100}}>{itemData!==null && qty!=="" && parseFloat((rateData.rate - rateData.rate * rateData.disc / 100) * qty).toFixed(0) }</TableCell>
            <TableCell className={classes.tblContentCell} sx={{width:100}}><IconButton onClick={clearNew}><Delete sx={{color:'red', fontSize:18}}/></IconButton></TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  </Grid>
  </LocalizationProvider>
);
});
export default memo(BillingTable);
